<template>
    <div class="main-footer">

            <div class="index-footer" :class="{'gary-bg':urlName!=='index'}">
                <div class="centerWidth clearfix">
                    <div class="footer-bottom">
                        <ul>
                            <li> <a href="/about.html">关于我们 </a></li>
                            <li class="divider"></li>
                            <li> <a href="https://shop189709270.taobao.com/?spm=a230r.7195193.1997079397.2.7YwgpJ" target="_blank"> 未来市场</a> </li>
                            <li class="divider"></li>
                            <li @click="goTop"> 返回顶部 </li>
                        </ul>
                        <div class="logo-box"><img :src="copyrightLogo" v-if="!!copyrightLogo"/></div>
                        <p style="padding-bottom: 10px;">版权所有 Copyright © 2016-2017 All Rights Reserved. &nbsp; &nbsp;  {{ copyrightText }}</p>
                        <p class="bottom">
                            <a href="http://beian.miit.gov.cn/" target="_blank">备案号：{{ icpCode }}</a>
                            <i>|</i>
                            <a target="_blank" :href='"https://www.beian.gov.cn/portal/registerSystemInfo?recordcode="+ policeCode'>
                                <img src="../../assets/images/icon/beian.png" style="vertical-align: text-bottom;">
                                <p style="margin-left: 5px; display: inline;">{{ policeText }}</p>
                            </a>
                        </p>
                    </div>
                </div>
            </div>

           <!-- <div class="m-footer" v-else-if="showMain">
                <div class="content">
                    <div>联系我们</div>
                    <p class="homeIcon">杭州市百井坊巷95号3楼，310003</p>
                    <p class="telIcon">联系电话：0571-88909745</p>
                    <p class="emailIcon">商务合作：TSBD@ooowin.com</p>
                </div>
                <div class="icp">
                    <a href="http://www.miitbeian.gov.cn/" target="_blank">备案号：浙ICP备16033261号-1</a>
                </div>
            </div>
            <div class="m-footer" v-else>
                <div class="mid" style="vertical-align: middle;line-height: 1.4rem;">
                    版权所有 Copyright © 2016-2017 All Rights Reserved.
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp; <img src='../../assets/images/icon/logo_footer.png' class="pub_pic" />
                </div>
            </div>-->
    </div>
</template>
<script>
import Bus from '../../pages/project_detail/bus.js';
export default {
    name:'PageFooter',
    data(){
        return{
            showMain:true,
            urlName:'',
            copyrightLogo:'',
            copyrightText:'',
            icpCode:'',
            policeText:'',
            policeCode:''
        }
    },
    created(){

    },
    mounted(){
        let href =  window.location.href;
        let hrefAtt = href.split('/');
        this.urlName = hrefAtt[hrefAtt.length-1].split('.htm')[0] || 'index';
        if(this.urlName.indexOf('index')<0){
            this.showMain = false;
        }
        // 监听 sass 项目配置文件
        Bus.$on('sassProjectConfigChange', (data) => {
			//console.log('sassProjectConfigChange----------------',data);
            this.copyrightLogo = data.copyrightLogo;
            this.copyrightText = data.copyright;
            this.icpCode = data.icp;
            this.policeText = data.police;
            this.policeCode = data.police.replace(/[^0-9]/ig,"");
			
		});
    },
    methods:{
        goTop(){
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }

    },
    components:{

    }
}
</script>
<style  lang="scss" scoped>
    $mainUrl:'../../assets/images';
    .index-footer{
        text-align:center;
        color:#fff;
        .logo-box{
            width: 310px;
            display: inline-block;
            margin-bottom:15px;
            img{width: 100%;height: auto;display: block;max-height: 28px}
        }
        p{
            font-size: 12px;
            line-height: 100%;
            img{
                width: 16px;
                position: relative;
                top: -1px;
            }

        }
        .bottom{
            color: #fff;
            padding-bottom: 10px;
            display: block;
            a{
                color: #fff;
            }
            i{
                margin: 0 20px;
            }
        }
    }
    .index-footer.gary-bg{
        padding-top: 40px;
        background-color: #9b9b9b
    }
    .m-footer {
        background-color: #fff;
        height: 54px;
        text-align: Center;
        font-size: 12px;
        line-height: 45px;
        color: #9B9B9B;
        width: 100%;
        .content{
            border-top: 1px solid lightblue;
            p{
                line-height: 27px;
                padding-left: 45px;
                display: inline-block;
            }
             p.homeIcon{
                 background: url("#{$mainUrl}/icon/logo_dzn.png") no-repeat;
                 background-size: 27px;
             }
            p.telIcon{
                background: url("#{$mainUrl}/icon/logo_lxdhn.png") no-repeat;
                background-size: 15px;
                background-position:6px;
            }
            p.emailIcon{
                background: url("#{$mainUrl}/icon/logo_yxn.png") no-repeat;
                background-size: 24px;
                background-position: 2px 1px;
            }
            p + p {
                margin-left: 60px;
            }
        }
        .m-footer .mid {
            display: inline-flex;
        }
        .pub_pic {
            height: 42px;
            margin: 6px;
            vertical-align: middle;
        }
    }
    .footer-bottom {
      ul {
          text-align:  center;
          margin-bottom: 10px;

          li{
              display: inline-block;
              text-align: center;
              font-size:16px;
              font-weight:500;
              color:rgba(255,255,255,1);
              vertical-align: middle;
              padding: 0 26px;
              cursor: pointer;
              a{
                color:rgba(255,255,255,1);
              }

          }
          li.divider{
            width:1px;
            height:16px;
            background:rgba(255,255,255,1);
            padding: 0;
          }
      }

    }
    /*@media only screen and (max-width: 800px) {
        .index-footer .footer-top{display: none}
        .footer-bottom p{
            text-align: left;
            padding:  0 0.5rem;
        }
        .m-footer {
            line-height:30px;
            .content{
                p{
                    width: 240px;
                    text-align: left;
                }
            }
            .content p + p{
                margin-left: 0;
            }
        }
    }*/
</style>
